import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue';
import { baseMixins } from '@common/mixins/baseMixins';

export default /*#__PURE__*/_defineComponent({
  __name: 'CommonTitle',
  props: {
    title: { default: '' },
    top: { default: 0 }
  },
  setup(__props: any) {



const { isEng } = baseMixins();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["title-wrapper", { eng: _unref(isEng) }]),
    style: _normalizeStyle({ marginTop: `${__props.top}px` })
  }, [
    _createElementVNode("span", null, _toDisplayString(__props.title), 1),
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})